import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { supabase } from '../services/supabaseService';
import VacancyDashboard from './VacancyDashboard';
import { Vacancy } from '../types';

interface VacancyDetailModalProps {
    vacancyId: string;
    currentUser: any;
    onClose: () => void;
}

const VacancyDetailModal: React.FC<VacancyDetailModalProps> = ({ vacancyId, currentUser, onClose }) => {
    const [vacancy, setVacancy] = useState<Vacancy | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadVacancy = async () => {
            const { data, error } = await supabase
                .from('vacancies')
                .select('*, client:clients!vacancies_client_id_fkey(*), eindklant:clients!vacancies_eindklant_id_fkey(*), opdrachtgever:clients!vacancies_opdrachtgever_id_fkey(*)')
                .eq('id', vacancyId)
                .single();
            if (data) {
                setVacancy({
                    ...data,
                    clientId: data.client_id
                });
            }
            setLoading(false);
        };
        loadVacancy();
    }, [vacancyId]);

    return (
        <div className="fixed inset-0 z-[400] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-[95vw] xl:max-w-[1400px] h-[95vh] flex flex-col overflow-hidden relative animate-in fade-in zoom-in-95 duration-200">
                {/* Header specifically for closing */}
                <div className="absolute top-4 right-4 z-10">
                    <button 
                        onClick={onClose}
                        className="bg-white border border-slate-200 p-1.5 rounded-full text-slate-500 hover:text-slate-900 hover:bg-slate-50 transition-colors shadow-sm"
                    >
                        <X size={16} />
                    </button>
                </div>

                {loading ? (
                    <div className="flex-1 flex flex-col items-center justify-center bg-slate-50">
                        <div className="w-8 h-8 border-4 border-[#0073e6] border-t-transparent rounded-full animate-spin mb-4"></div>
                        <p className="text-[11px] font-bold text-slate-400 uppercase tracking-widest">Vacature laden...</p>
                    </div>
                ) : vacancy ? (
                    <VacancyDashboard 
                        vacancy={vacancy}
                        onBack={onClose}
                        user={currentUser}
                    />
                ) : (
                    <div className="flex-1 flex flex-col items-center justify-center bg-slate-50">
                        <p className="text-[13px] font-bold text-slate-500">Vacature niet gevonden.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VacancyDetailModal;
